import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from '../services/configuration/configuration.service';
import { LoggerService } from '../services/logger-services/logger.service';
import { DevAuthService } from '../services/dev-service/dev-auth/dev-auth.service';
import Config from '../config/config.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Impact_Chatbot_UI';
  
  showLoginForm = Config.LoginForm;
  /** When dev login is enabled, false until we know there is no valid session. */
  isLoggedIn = false;

  private readonly AppComponentError = (error: any) =>
    `[AppComponent] - ${JSON.stringify(error)}`;

  constructor(
    private readonly configService: ConfigurationService,
    private readonly loggerService: LoggerService,
    private devAuthService: DevAuthService
  ) {}

  ngOnInit(): void {
    if (this.showLoginForm && this.devAuthService.hasActiveDevSession()) {
      this.isLoggedIn = true;
    }
  }

  onLoginSuccess(): void {
    this.isLoggedIn = true;
  }
}